export default class ServiceContainerComponent {
    constructor(serviceContainerComponentElement) {
        this.serviceContainerComponentElement = serviceContainerComponentElement;
    }
  
    init() {
      if (!this.serviceContainerComponentElement) {
        return;
      }
      
      const { hover } = this.serviceContainerComponentElement.dataset;
      const dialog = this.serviceContainerComponentElement.closest('.swa-dialog-fragment') ? true : false;

      if (dialog && hover) {
        this.serviceContainerComponentElement.addEventListener('mouseenter', () => {
            this.serviceContainerComponentElement.style.backgroundColor = `${hover}`;
        });
        this.serviceContainerComponentElement.addEventListener('mouseleave', () => {
            this.serviceContainerComponentElement.style.backgroundColor = '';
        });
      }
    }
  }